"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROW_CATEGORY_KEY = 'base';
exports.ROW_PARENT_COMPONENT_KEY = 'table';
exports.ROW_COMPONENT_KEY = 'row';